<template>
  <div class="product__item" :class="{ 'product__item--uniform': uniformSize }">
    <!-- Deal countdown bar -->
    <div v-if="dealEndDate && isDealActive" class="deal-countdown-bar">
      <i class="fas fa-clock"></i>
      <countdown-timer :end-date="dealEndDate"></countdown-timer>
    </div>

    <div class="product__thumb fix">
      <div class="product-image w-img">
        <router-link :to="`/product-details/${product.product_id}`">
          <img :src="product.image" alt="product" />
        </router-link>
      </div>
      <div class="product__offer" v-if="product.discount_presentage">
        <span class="discount">-{{ product.discount_presentage }}%</span>
      </div>
      <div class="product-action">
      </div>
    </div>
    <div class="product__content">
      <h6 :class="{ 'title--uniform': uniformSize }">
        <router-link :to="`/product-details/${product.product_id}`">{{ product.title }}</router-link>
      </h6>

      <div class="price mb-10" :class="{ 'price--uniform': uniformSize }">
        <h5><span :class="{ 'price-value--uniform': uniformSize }">
          Rs. {{ formatPrice(product.price) }}
        </span></h5>
        <template v-if="product.discount_presentage > 0">
          <del class="original-price--uniform">Rs. {{ formatPrice(calculateOriginalPrice(product.price, product.discount_presentage)) }}</del>
          <span class="discount-label--uniform">{{ product.discount_presentage }}% Off</span>
        </template>
      </div>
     
      <!-- <div class="progress mb-5">
          <div
            class="progress-bar bg-danger"
            role="progressbar"
            :style="{ width: `${(product.sold / product.quantity) * 100}%` }"
            aria-valuenow="100"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div class="progress-rate">
          <span>Sold: {{ product.sold }}/{{ product.quantity }}</span>
        </div> -->
    </div>
    <div class="product__add-cart text-center">
      <router-link v-if="uniformSize" :to="`/product-details/${product.product_id}`"
        class="cart-btn product-modal-sidebar-open-btn d-flex align-items-center justify-content-center w-100">
        View More
      </router-link>
      <template v-else>
        <button v-if="!isItemInCart(product)" @click="cartStore.addCartProduct(product)" type="button"
          class="cart-btn product-modal-sidebar-open-btn d-flex align-items-center justify-content-center w-100">
          Add to Cart
        </button>
        <router-link :to="'/cart'" v-if="isItemInCart(product)"
          class="cart-btn product-modal-sidebar-open-btn d-flex align-items-center justify-content-center w-100">
          View Cart
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/useCartStore"
import { useCurrency } from "@/composables/useCurrency"
import { calculateOriginalPrice } from "@/utils/utils"
import CountdownTimer from '@/components/countdown-timer.vue'

export default {
  name: "ProductItem",
  components: {
    CountdownTimer,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    uniformSize: {
      type: Boolean,
      default: false,
    },
    dealEndDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    isDealActive() {
      if (!this.dealEndDate) return false
      return new Date(this.dealEndDate).getTime() > Date.now()
    },
  },
  setup(props) {
    const cartStore = useCartStore()
    const { currencySymbol, formatPrice } = useCurrency()

    function isItemInCart(product) {
      return cartStore.cart_products.some((prd) => prd.id === product.id)
    }

    return {
      cartStore,
      currencySymbol,
      formatPrice,
      isItemInCart,
      calculateOriginalPrice,
      // eslint-disable-next-line vue/no-dupe-keys
      product: props.product,
    }
  },
};
</script>

<style scoped>
/* ── Deal countdown bar at top of card ──────────── */
.deal-countdown-bar {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 10px;
  font-size: 11px;
  border-radius: 12px 12px 0 0;
}
.deal-countdown-bar > i {
  color: var(--fe-accent, #fcbe00);
  font-size: 12px;
}

.deal-countdown-bar :deep(ul) {
  display: flex;
  gap: 2px;
  margin: 0;
  padding: 0;
}
.deal-countdown-bar :deep(li) {
  list-style: none;
  font-size: 9px;
  color: rgba(255,255,255,0.6);
  text-transform: uppercase;
  text-align: center;
  padding: 0 5px;
  line-height: 1;
}
.deal-countdown-bar :deep(li span) {
  display: block;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
}

.product-stock h5 del {
  color: #cc1414;
}

.product__item--uniform {
  height: 100%;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.product__item--uniform .product__thumb {
  min-height: 220px;
}

.product__item--uniform .product__thumb .product-image {
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product__item--uniform .product__thumb .product-image a {
  width: 170px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product__item--uniform .product__thumb .product-image img {
  max-width: 170px;
  max-height: 200px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.product__item--uniform .product__content {
  min-height: 110px;
  padding: 8px 18px 74px;
}

.product__item--uniform .product__content .title--uniform {
  margin: 0;
  min-height: 42px;
}

.product__item--uniform .product__content .title--uniform a {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 2px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #111827 !important;
}

.product__item--uniform .price--uniform {
  margin-top: 12px;
}

.product__item--uniform .price-value--uniform {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: #e65100;
}

/* Top Deals button: round corners + white label */
.product__item--uniform .product__add-cart .cart-btn {
  border-radius: 999px !important;
  color: #ffffff !important;
  font-weight: 800 !important;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border: none !important;
  background: linear-gradient(
    145deg,
    var(--fe-accent, #fcbe00) 0%,
    var(--fe-accent-hover, #e5ac00) 100%
  ) !important;
  box-shadow:
    0 6px 16px color-mix(in srgb, var(--fe-accent, #fcbe00) 38%, transparent),
    inset 0 1px 0 rgba(255, 255, 255, 0.35) !important;
}

.product__item--uniform .product__add-cart .cart-btn:hover {
  color: #ffffff !important;
  filter: brightness(1.05);
}

@media (max-width: 767px) {
  .product__item--uniform .product__content {
    padding: 8px 14px 72px;
  }

  .product__item--uniform .product__content .title--uniform a {
    font-size: 12px;
  }

  .product__item--uniform .price-value--uniform {
    font-size: 14px;
  }
}

.original-price--uniform {
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  color: #999;
  margin-left: 6px;
}

.discount-label--uniform {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  color: #e65100;
  margin-left: 4px;
}

@media (max-width: 767px) {
  .product__item:not(.product__item--uniform) .product__content h6 {
    font-size: 12px;
  }
}

</style>